import { Component, computed, input } from '@angular/core';
import { PrettifyCharsPipe } from '../../pipes';

const EMPTY_CODE = '••••••';

@Component({
	standalone: true,
	imports: [PrettifyCharsPipe],
	selector: 'ctx-code-display',
	templateUrl: 'code-display.component.html',
	styleUrl: 'code-display.component.scss',
})
export class CodeDisplayComponent {
	readonly code = input<string | null>(null);
	readonly prettify = input<boolean>(true);

	readonly placeholder = EMPTY_CODE;
}
